import { render, staticRenderFns } from "./ParticaLoader.vue?vue&type=template&id=388d6cb4&"
import script from "./ParticaLoader.vue?vue&type=script&lang=ts&"
export * from "./ParticaLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports